import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'pci-layout',
    standalone: true,
    imports: [RouterOutlet, HeaderComponent, FooterComponent, CommonModule],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent {
    mobileTrayOpened = false;

    get year(): number {
        return new Date().getFullYear();
    }

    onTrayStateChanged(isOpened: boolean): void {
        this.mobileTrayOpened = isOpened;
    }
}

// NOTE: HeaderComponent, FooterComponent (with Navbar inside Header) provide layout chrome.
